var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{attrs:{"id":"audioPlayer","controls":"","crossOrigin":"anonymous"}},[_c('source',{attrs:{"src":_vm.audioUrl,"type":"audio/mpeg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }